import { render, staticRenderFns } from "./BadgeNotification.vue?vue&type=template&id=70c4f6d7&scoped=true&"
import script from "./BadgeNotification.vue?vue&type=script&lang=js&"
export * from "./BadgeNotification.vue?vue&type=script&lang=js&"
import style0 from "./BadgeNotification.vue?vue&type=style&index=0&id=70c4f6d7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c4f6d7",
  null
  
)

export default component.exports